import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { AppLoginContainerModel } from '../../../../../models/aggregates/id';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa, Pagination } from '../shared';
import { ApiResponseModel, PagingResponseModel } from '../shared/api-response.model';
import { Observable } from 'rxjs';

// /core2/platform/dm/iam/app-login

@Injectable({
  providedIn: 'root'
})
export class AppLoginService extends BaseApiTemplateService<AppLoginContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + 'app-login';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + 'app-login';
    this.httpClient = http;
  }

  // /core2/platform/dm/iam/app-login/staging_tenant/login-tenant-ep/query? || customized method
  getByCriteriaByTenant(pagination: Pagination, tenantCode: string, apiVisa: ApiVisa): Observable<PagingResponseModel<AppLoginContainerModel>> {
    let url = this.apiUrl + '/'+ tenantCode + '/login-tenant-ep/query?'
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path + '/'+ tenantCode + '/login-tenant-ep/query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<AppLoginContainerModel>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }


  // upsert app_login data in tenant /populate-to-tenant/{tenantCode}/login-tenant-ep
  populateToTenant(tenantCode: string, dto: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url = this.apiUrl + `/populate-to-tenant/${tenantCode}/login-tenant-ep`;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + `/populate-to-tenant/${tenantCode}/login-tenant-ep`;
    }
    return this.httpClient.post<ApiResponseModel<any>>(url, dto, this.getHttpHeader(visa));
  }  

  
  //  /core2/platform/dm/iam/app-login/user-deletion/sysadmin-ep/{guid}
  deletePlatformUsersSyadminEp(appLogin: string, apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url = this.apiUrl + '/user-deletion/sysadmin-ep/' + appLogin;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path + '/user-deletion/sysadmin-ep/' + appLogin;
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }


  //  /core2/platform/dm/iam/app-login/user-deletion/{tenantCode}/tenant-admin-ep/{guid}
  deletePlatformUsersTenantAdminEp(tenantCode: string, appLogin: string, apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url = this.apiUrl + '/user-deletion/'+ tenantCode +'/tenant-admin-ep/' + appLogin;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path + '/user-deletion/'+ tenantCode +'/tenant-admin-ep/' + appLogin;
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }
}
